<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="submit-trial-balance-container">
    <div class="pageHeader" id="submitServicerTransferHeader">Submit Trial Balance</div>
    <div class="warningMessage" *ngIf="warningMessage"><br><li>{{warningMessage}}</li></div>

    <div class="errorMessage" *ngIf="errorMessage?.length">
      <br>
      You must correct the following error(s) before proceeding:
      <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>

    <form  [formGroup]="submitTrialBalanceForm"  (ngSubmit)="submitBalanceForm()">
      <div class="submit-trial-balance">
        <div>
          <div class="ui-g commonLabel glypha-font">Identify Loan:</div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Loan Number:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="loanNumber" maxlength="10" formControlName="loanNumber">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Reporting Period:</div>
            <div class="ui-g-3">
              <fm-calendar id ="reportingPeriod" dateFormat="mm/yy" placeholder="MM/YYYY" formControlName="reportingPeriod"
              view="month" [yearNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">FHA Case Number:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="fhaCaseNumber" maxlength="10" formControlName="fhaCaseNumber">
                <fm-select
                [options]="serNumber"
                ariaLabelledBy="default"
                formControlName="fhaNumber2"
                placeholder="Choose"
              ></fm-select>
            </div>
            <div class="ui-g-6"></div>
          </div>
<!---->     <div class="ui-g"><hr class="trial-hr-style"></div>
            <div class="ui-g commonLabel glypha-font">Enter loan balance trial Information:</div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Interest Rate:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="interestRate" formControlName="interestRate">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Payment Plan:</div>
            <div class="ui-g-3">
                <fm-select
                [options]="pmtPlanOpts"
                ariaLabelledBy="default"
                formControlName="paymentPlan"
                placeholder="Choose"
              ></fm-select>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Loan Balance:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="loanBalance" formControlName="loanBalance">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Net Prin Limit:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="netPrinLimit" formControlName="netPrinLimit">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Orig Line Of Credit:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="origLoc" formControlName="origLoc">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Net Line Of Credit:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="netLoc" formControlName="netLoc">
            </div>
          </div>
          <div class="ui-g commonLabel glypha-font">Set Asides</div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">1st Year Prop Chgs:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="yearPropChgs" formControlName="yearPropChgs">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Tax/Insurance:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="taxOrIns" formControlName="taxOrIns">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Repairs:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="repairs" formControlName="repairs">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Servicing Fee:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="servicingFee" formControlName="servicingFee">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Scheduled Payment:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="schdPayment" formControlName="schdPayment">
            </div>
            <div class="ui-g-3 fieldLabel glypha-font">Term:</div>
            <div class="ui-g-3">
                <input type="text" fmTextInput id="term" formControlName="term">
            </div>
          </div>

          <div class="ui-g"><hr class="trial-hr-style"></div>
          <div class="ui-g commonLabel glypha-font">Enter purchasing data trial Information:</div>
          <div class="ui-g">
                <div class="ui-g-3 fieldLabel glypha-font">Closing Date:</div>
                <div class="ui-g-3">
                  <fm-calendar id ="closingDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="closingDate"
                [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
                </div>
                <div class="ui-g-3 fieldLabel glypha-font">Borrower Birthdate:</div>
                <div class="ui-g-3">
                  <fm-calendar id ="borrowerBirthDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="borrowerBirthDate"
                [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
                </div>
          </div>
          <div class="ui-g">
                <div class="ui-g-3 fieldLabel glypha-font">Exp Avg Int Rate:</div>
                <div class="ui-g-3">
                    <input type="text" fmTextInput id="expAvgIntRate" formControlName="expAvgIntRate">
                </div>
                <div class="ui-g-3 fieldLabel glypha-font">Max Claim Amount:</div>
                <div class="ui-g-3">
                    <input type="text" fmTextInput id="maxClaimAmt" formControlName="maxClaimAmt">
                </div>
          </div>
          <div class="ui-g">
                <div class="ui-g-3 fieldLabel glypha-font">Margin:</div>
                <div class="ui-g-3">
                    <input type="text" fmTextInput id="margin" formControlName="margin">
                </div>
                <div class="ui-g-3 fieldLabel glypha-font">Service Fee:</div>
                <div class="ui-g-3">
                    <input type="text" fmTextInput id="serviceFee" formControlName="serviceFee">
                </div>
          </div>

          <div class="ui-g">
            <div class="ui-g-6">
                <button fmButton id="btnSubmit" type="submit" [primary]="true" [small]="true" label="Submit"
                        class="buttonmargin"></button>
                <button fmButton id="btnClear" type="button" label="Clear" [small]="true" (click)="onClear()"
                        class="buttonmargin"></button>
                <button fmButton id="btnCancel" type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
                        class="buttonmargin"></button>
            </div>
            <div class="ui-g-6"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
